import { Grid } from "@mui/material";
import * as React from "react";
import { Create, TextInput, SelectInput, required } from "react-admin";
import { SimpleForm } from "src/enterprise/ra-rbac";
import { AttributeTypeEnum } from "../../../common/enum";
import { AttributeCreateComponent } from "./AttributeComponent";

export const AttributeCreate = () => (
  <Create component={AttributeCreateComponent}>
    <SimpleForm>
      <Grid container rowSpacing={1} columnSpacing={2}>
        <Grid item sm={12} lg={8}>
          <TextInput source="code" validate={required()} />
        </Grid>
        <Grid item sm={12} lg={8}>
          <TextInput source="name" validate={required()} />
        </Grid>
        <Grid item sm={12} lg={8}>
          <SelectInput source="type" choices={AttributeTypeEnum} validate={required()} />
        </Grid>
      </Grid>
    </SimpleForm>
  </Create>
);
